import { Link } from 'react-router-dom';

export default function SoyProteinColumnPage() {
  return (
    <div className="min-h-screen bg-white text-[#5D4037]">
      {/* Header */}
      <header className="bg-white border-b border-[#E0D7D0] sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <span className="font-bold text-xl text-[#bc6355]">プロテイン選びの教科書</span>
        </div>
      </header>

      {/* Breadcrumb */}
      <nav className="bg-[#FAF9F8] border-b border-[#E0D7D0]">
        <div className="container mx-auto px-6 py-3">
          <ul className="flex items-center gap-2 text-sm">
            <li>
              <a
                href="https://soyproteinranking.com/"
                className="flex items-center gap-2 text-[#8D6E63] hover:text-[#bc6355] transition-colors whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center text-[#bc6355]">
                  <i className="ri-home-4-line"></i>
                </span>
                <span>トップ</span>
              </a>
            </li>
            <li className="text-[#BCAAA4]">/</li>
            <li className="text-[#5D4037] whitespace-nowrap">
              ソイプロテインとは？特徴とホエイとの違い
            </li>
          </ul>
        </div>
      </nav>

      {/* Main Content */}
      <main className="container mx-auto px-6 py-12 max-w-4xl">
        {/* Hero Section */}
        <section className="mb-12">
          <h1 className="text-3xl font-bold text-white mb-6 bg-gradient-to-r from-[#bc6355] to-[#d4847a] px-6 py-4 rounded-lg leading-tight">
            ソイプロテインとは？ホエイとの違いや特徴・利点を徹底解説
          </h1>

          <p className="text-[#5D4037] leading-relaxed mb-4">
            「プロテインを始めたいけど、種類が多すぎてどれを選べばいいかわからない」と悩んでいませんか？
          </p>

          <p className="text-[#5D4037] leading-relaxed">
            プロテインには大きく分けて、大豆を原料とした
            <span className="text-[#bc6355] font-semibold underline decoration-[#F9EBEA] decoration-4">
              「ソイプロテイン」
            </span>
            と、牛乳を原料とした「ホエイプロテイン」があります。それぞれの違いを正しく理解することで、あなたの目的に合った最適な選択ができるようになります。
          </p>
        </section>

        {/* Feature Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#5D4037] mb-6 pb-3 border-b-4 border-[#bc6355]">
            ソイプロテインの主な特徴
          </h2>

          <p className="text-[#5D4037] leading-relaxed mb-6">
            ソイプロテインは、その名の通り「大豆」からタンパク質を抽出した植物性のプロテインです。健康や美容を意識する方に特に支持されています。
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="p-4 bg-[#FDF8F3] rounded-lg border border-[#E8DDD4]">
              <h4 className="font-bold text-[#bc6355] mb-2">ゆっくり吸収</h4>
              <p className="text-sm">
                消化吸収に時間がかかるため、腹持ちが良く、ダイエット中の強い味方になります。
              </p>
            </div>
            <div className="p-4 bg-[#FDF8F3] rounded-lg border border-[#E8DDD4]">
              <h4 className="font-bold text-[#bc6355] mb-2">イソフラボン</h4>
              <p className="text-sm">
                女性ホルモンに似た働きをする成分が含まれ、美容面でのサポートも期待できます。
              </p>
            </div>
            <div className="p-4 bg-[#FDF8F3] rounded-lg border border-[#E8DDD4]">
              <h4 className="font-bold text-[#bc6355] mb-2">植物性100%</h4>
              <p className="text-sm">
                乳製品を控えている方や、動物性脂肪を摂りたくない方にも安心です。
              </p>
            </div>
          </div>
        </section>

        {/* Comparison Table */}
        <section className="mb-12">
          <h3 className="text-xl font-bold text-[#5D4037] mb-6">
            ホエイプロテインとの決定的な違い
          </h3>

          <div className="overflow-hidden rounded-lg border border-[#E0D7D0] shadow-sm mb-8 bg-white">
            <table className="w-full text-center">
              <thead>
                <tr className="bg-[#FAF9F8]">
                  <th className="px-6 py-4 text-sm font-semibold text-[#5D4037] border-b border-[#E0D7D0]">
                    特徴
                  </th>
                  <th className="px-6 py-4 text-sm font-semibold text-[#bc6355] border-b border-[#E0D7D0]">
                    ソイ
                  </th>
                  <th className="px-6 py-4 text-sm font-semibold text-[#5D4037] border-b border-[#E0D7D0]">
                    ホエイ
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[#E0D7D0]">
                <tr>
                  <td className="px-6 py-4 bg-[#FAF9F8] font-semibold text-sm">原料</td>
                  <td className="px-6 py-4 text-[#5D4037] text-sm">大豆（植物性）</td>
                  <td className="px-6 py-4 text-[#5D4037] text-sm">牛乳（動物性）</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 bg-[#FAF9F8] font-semibold text-sm">吸収速度</td>
                  <td className="px-6 py-4 text-[#5D4037] text-sm">遅い（5〜6時間）</td>
                  <td className="px-6 py-4 text-[#5D4037] text-sm">速い（1〜2時間）</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 bg-[#FAF9F8] font-semibold text-sm">主な目的</td>
                  <td className="px-6 py-4 text-[#bc6355] font-semibold text-sm">
                    引き締め・美容
                  </td>
                  <td className="px-6 py-4 text-[#5D4037] text-sm">筋肉量アップ</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Pros & Cons Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#5D4037] mb-6 pb-3 border-b-4 border-[#bc6355]">
            ソイプロテインのメリット・デメリット
          </h2>

          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#5D4037] mb-4 border-l-4 border-[#bc6355] pl-3">
              メリット：ダイエットと美容の強力なサポート
            </h4>
            <p className="text-[#5D4037] leading-relaxed">
              一番のメリットは<strong>「満足感の持続」</strong>です。ゆっくり消化されるため空腹を感じにくく、置き換えや間食の代わりとして非常に優秀です。また、大豆タンパク質自体がコレステロール値の改善を助けるとも言われています。
            </p>
          </div>

          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#5D4037] mb-4 border-l-4 border-[#BCAAA4] pl-3">
              デメリット：飲み心地と吸収スピード
            </h4>
            <p className="text-[#5D4037] leading-relaxed">
              ホエイに比べると<strong>「水に溶けにくい」「独特の大豆感がある」</strong>といった点が挙げられます。また、筋トレ直後の「素早い栄養補給」には不向きなため、トレーニング後に飲む場合はホエイを選ぶのが一般的です。
            </p>
          </div>
        </section>

        {/* Recommended For Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#5D4037] mb-6 pb-3 border-b-4 border-[#bc6355]">
            ソイプロテインはこんな人におすすめ
          </h2>

          <div className="bg-gradient-to-br from-[#FAF9F8] to-[#F3EFEF] rounded-xl p-8 border border-[#E0D7D0] shadow-sm">
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  1
                </div>
                <p className="text-[#5D4037]">
                  腹持ちの良いプロテインで無理なくダイエットしたい
                </p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  2
                </div>
                <p className="text-[#5D4037]">
                  筋肉を太くするより、しなやかに体を引き締めたい
                </p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  3
                </div>
                <p className="text-[#5D4037]">
                  大豆イソフラボンで美容やエイジングケアも意識したい
                </p>
              </li>
            </ul>
          </div>
        </section>

        {/* Summary Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#5D4037] mb-6 pb-3 border-b-4 border-[#bc6355]">
            まとめ
          </h2>

          <div className="bg-[#bc6355] text-white rounded-xl p-8 shadow-sm">
            <div className="space-y-4 leading-relaxed">
              <p>
                ソイプロテインは、<strong>「ヘルシーに、綺麗に、ゆっくり痩せたい」</strong>という願いを叶える植物性のプロテインです。
              </p>
              <p>
                ホエイプロテインのような瞬発的な筋肉ケアには向きませんが、毎日の健康習慣やダイエットサポートとしては、これ以上ないパートナーとなります。
              </p>
              <p className="pt-4 text-center font-bold border-t border-[#d4847a]">
                自分のライフスタイルに合わせて、賢くソイプロテインを取り入れていきましょう。
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}